import { Component } from '@angular/core';

@Component({
  selector: 'app-user-setting-icon',
  templateUrl: './user-setting-icon.component.html',
  styleUrl: './user-setting-icon.component.scss',
})
export class UserSettingIconComponent {}
